import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

import { InviteFormFields, InviteFormFieldsForStaff } from '../types';

export const peoPayrollProviderStaffInviteValidationSchema = yup.object({
  [InviteFormFields.staff]: yup
    .array()
    .of(
      yup.object({
        [InviteFormFieldsForStaff.email]: emailValidationSchema
          .typeError('Required')
          .nullable()
          .required('Required'),
      }),
    )
    .min(1),
});
